import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Jan/subs.vtt';
import poster from '@/static/assets/reviews/Jan/video.jpg';

export const Jan: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Home],
  reviewerName: 'Jan',
  videoUrl: `${ASSETS_URL}/home/Jan_Home.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
